/**
 * FAQs block — tabbed categories + accordion items.
 */
export const FaqsBlock = {
	init() {
		const blocks = document.querySelectorAll( '.block-faqs' );
		if ( ! blocks.length ) return;

		blocks.forEach( ( block ) => this.initBlock( block ) );
	},

	initBlock( block ) {
		// Tabs.
		const tabs = block.querySelectorAll( '[data-faq-tab]' );
		const panels = block.querySelectorAll( '[data-faq-panel]' );

		tabs.forEach( ( tab ) => {
			tab.addEventListener( 'click', () => {
				const index = tab.getAttribute( 'data-faq-tab' );

				tabs.forEach( ( t ) => {
					const active = t === tab;
					t.classList.toggle( 'is-active', active );
					t.setAttribute( 'aria-selected', active ? 'true' : 'false' );
				} );

				panels.forEach( ( panel ) => {
					const active = panel.getAttribute( 'data-faq-panel' ) === index;
					panel.classList.toggle( 'is-active', active );
				} );
			} );
		} );

		// Accordion items.
		const items = block.querySelectorAll( '[data-faq-item]' );
		items.forEach( ( item ) => {
			const btn = item.querySelector( '.block-faqs__question' );
			if ( ! btn ) return;

			btn.addEventListener( 'click', () => {
				const open = item.classList.toggle( 'is-open' );
				btn.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			} );
		} );
	},
};
